import { createContext, useContext, useEffect, useState } from "react";

const CartContext = createContext(null);
const KEY = "dreamonds_cart";

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem(KEY)) || [];
    } catch {
      return [];
    }
  });
  const [open, setOpen] = useState(false);

  useEffect(() => {
    localStorage.setItem(KEY, JSON.stringify(items));
  }, [items]);

  const addItem = (product, opts) => {
    const { color, metal, metalLabel, carat, shape, price, image, ringSize, bandWidth } = opts;
    const lineId = `${product.id}__${color}__${metal || "14k"}__${carat || 1}__${ringSize || "-"}__${bandWidth || "-"}`;
    setItems((prev) => {
      const existing = prev.find((i) => i.lineId === lineId);
      if (existing) {
        return prev.map((i) => (i.lineId === lineId ? { ...i, qty: i.qty + 1 } : i));
      }
      return [
        ...prev,
        {
          lineId,
          productId: product.id,
          name: product.name,
          category: product.category_label || product.category,
          color,
          metal,
          metalLabel,
          carat,
          shape,
          image,
          price,
          ringSize: ringSize || null,
          bandWidth: bandWidth || null,
          qty: 1,
        },
      ];
    });
    setOpen(true);
  };

  const updateQty = (lineId, qty) =>
    setItems((prev) =>
      prev.map((i) => (i.lineId === lineId ? { ...i, qty: Math.max(1, qty) } : i))
    );

  const removeItem = (lineId) => setItems((prev) => prev.filter((i) => i.lineId !== lineId));
  const clear = () => setItems([]);

  const count = items.reduce((s, i) => s + i.qty, 0);
  const total = items.reduce((s, i) => s + i.qty * i.price, 0);

  return (
    <CartContext.Provider
      value={{ items, addItem, updateQty, removeItem, clear, count, total, open, setOpen }}
    >
      {children}
    </CartContext.Provider>
  );
}

export const useCart = () => useContext(CartContext);
